import { useTheme } from "@mui/material";
import { GRID_DETAIL_PANEL_TOGGLE_FIELD, GridColDef } from "@mui/x-data-grid-pro";
import { useFormat } from "@sinch/core/hooks/format";
import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ComponentRow } from "@sinch/components/application/RateComponentsMarginTable/RateComponentsMargin";
import { RateDetailPanelToggle } from "@sinch/components/application/RateComponentsMarginTable/RateDetailPanelToggle";
import { useCommonRatesColumns } from "@sinch/components/application/RatesCompositionTable/hooks";

export const useComponentRatesColumns = (): GridColDef<ComponentRow>[] => {
  const { t } = useTranslation(["common", "draft"]);
  const { num } = useFormat();
  const { palette } = useTheme();
  const commonColumns = useCommonRatesColumns<ComponentRow>();

  return useMemo<GridColDef<ComponentRow>[]>(
    () => [
      ...commonColumns,
      {
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        renderCell: (params) => <RateDetailPanelToggle {...params} />,
        resizable: false,
        width: 50,
        align: "center",
      },
    ],
    [t, num, palette.success.main]
  );
};
